import { iFacadeConfig } from '@andbank-myinvestor/arq/lib/onboarding';

import { config as communicationConfig } from './communication-config';
import { config as i18nConfig } from './i18n-config';

const arqConfig: iFacadeConfig = {
	communicationConfig,
	i18nConfig,
	authConfig: {
		enableAuth: true,
	},
};

export { arqConfig };
